exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vp-top-right {\n  position: absolute;\n  padding: 0.1rem;\n  top: 0;\n  right: 0;\n  text-align: right; }\n\n.vp-top-left {\n  position: absolute;\n  padding: 0.1rem;\n  top: 0;\n  left: 0;\n  text-align: left; }\n", ""]);

